/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Country_Locked_HelpInputs */



/**
* | output |
* | --- |
* | "Your country is set by the Inner Circle or your National Coordinator. Contact them to change it." |
*
* @param {Profile_Country_Locked_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_country_locked_help = /** @type {((inputs?: Profile_Country_Locked_HelpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Country_Locked_HelpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre pays est défini par l'Inner Circle ou votre Coordinateur National. Contactez-les pour le changer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu país lo fija el Inner Circle o tu Coordinador Nacional. Contacta con ellos para cambiarlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu país é definido pelo Inner Circle ou pelo seu Coordenador Nacional. Fale com eles para alterá-lo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo paese è impostato dall'Inner Circle o dal tuo Coordinatore Nazionale. Contattali per cambiarlo.")
	return /** @type {LocalizedString} */ ("Your country is set by the Inner Circle or your National Coordinator. Contact them to change it.")
});